// This file was automatically generated from render.chartReqActFeedItemSharedNew.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.chartReqActFeedItemSharedNew');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartReqActFeedItemSharedNew.actions = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedItemColActionsRA">', (opt_data.actions.actionLink) ? '<a class="el8FeedItemActionLinkNew el8FeedActionsRA ml10 ' + soy.$$escapeHtml(opt_data.actions.actionLink.htmlClass) + '" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">' + soy.$$escapeHtml(opt_data.actions.actionLink.name) + '</a>' : '', (opt_data.actions.secondActionLink) ? '<a class="el8FeedItemActionLinkNew el8FeedActionsRA ml10 ' + soy.$$escapeHtml(opt_data.actions.secondActionLink.htmlClass) + '" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">' + soy.$$escapeHtml(opt_data.actions.secondActionLink.name) + '</a>' : '', (! opt_data.actions.secondActionLink && opt_data.actions.hasActionsMenu) ? '<a class="el8FeedItemActionLinkNew el8FeedActionsRA ml10 chart-feed-actions-trigger-new" data-from-ra="true" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '"><span class="el8FeedActionsLink">Actions</span></a>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
